import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import { apiDefaultFetcher, apiDeleteFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  CreatePermissionTemplateResponse,
  CreatePermissionTemplateVars,
  DeletePermissionTemplateResponse,
  DeletePermissionTemplateVars,
  ListPermissionTemplatesResponse,
  ListPermissionTemplatesVars,
  PermissionTemplateApiPath,
  UpdatePermissionTemplateResponse,
  UpdatePermissionTemplateVars
} from '@/common/api/params/permissionTemplate'

export const usePermissionTemplateListApi = (vars: ListPermissionTemplatesVars) => {
  return useSWR<ListPermissionTemplatesResponse, Response, [string, ListPermissionTemplatesVars]>(
    [PermissionTemplateApiPath.LIST_PERMISSION_TEMPLATES, vars],
    apiDefaultFetcher
  )
}

export const usePermissionTemplateGetApi = ({
  site_id,
  template_id
}: {
  site_id: number
  template_id: number
}) => {
  const response = usePermissionTemplateListApi({ site_id })
  return {
    ...response,
    data: response.data ? response.data.find((t) => t.id === template_id) : undefined
  }
}

export const usePermissionTemplateCreateApi = (
  options?: MutationOptions<CreatePermissionTemplateResponse>
) => {
  return useCallMutation<CreatePermissionTemplateResponse, CreatePermissionTemplateVars>(
    PermissionTemplateApiPath.CREATE_PERMISSION_TEMPLATE,
    options
  )
}

export const usePermissionTemplateUpdateApi = (
  options?: MutationOptions<UpdatePermissionTemplateResponse>
) => {
  return useCallMutation<UpdatePermissionTemplateResponse, UpdatePermissionTemplateVars>(
    PermissionTemplateApiPath.UPDATE_PERMISSION_TEMPLATE,
    options,
    apiPutFetcher
  )
}

export const usePermissionTemplateDeleteApi = (
  options?: MutationOptions<DeletePermissionTemplateResponse>
) => {
  return useCallMutation<DeletePermissionTemplateResponse, DeletePermissionTemplateVars>(
    PermissionTemplateApiPath.DELETE_PERMISSION_TEMPLATE,
    options,
    apiDeleteFetcher
  )
}
